export default {
    component: 'scb',
    name: 'scb',
    fields: [
      {
        param: 'plant_id',
        type: 'number',
        required: true,
        identifier: true,
        hidden: true
      },
      {
        name: 'Block ID',
        param: 'block_id',
        type: 'number',
        required: true,
        identifier: true,
        description:`> Should always start from ID **"1"**`
      },
      {
        name: 'Room ID',
        param: 'room_id',
        type: 'number',
        required: true,
        identifier: true,
        description: `> For each block, room id should start from **"1"**`
      },
      {
        name: 'Room Name',
        param: 'room_name',
        type: 'text',
        description: `> For each block room name should be unique.`
      },   
      {
        name: 'DC Capacity',
        param: 'dc_capacity',
        type: 'number',
        description: `> Its a mandatory data. It should be sum of all the inverters capacities present in that specific room.`
      }, 
      {
        name: 'AC Capacity',
        param: 'ac_capacity',
        type: 'number',
        description: `> Its a mandatory data for the calculation of **"PR"**. It should be sum of all the inverters capacities present in that specific room`
      },       
      {
        name: 'Irradiance (Ref. device Id)',
        param: 'irr_ref_device_id',
        type: 'number',
        description: `> In order to plot **"irradiance(PoA)"** graph in inverter dashboard we need to refer to which ws id PoA data exist.`
      },
      {
        name: 'Irradiance (Ref. block Id)',
        param: 'irr_ref_block_id',
        type: 'number',
        description: `> In order to plot **"irradiance(PoA)"** graph in inverter dashboard we need to refer to which block id, the ws id PoA data exist.`
      },
      {
        name: 'Temperature (Ref. device Id)',
        param: 'temp_ref_device_id',
        type: 'number',
        description: `> In order to plot **"Temperature"** data in Temp Corrected PR dashboard we need to refer to which block id, the ws id temperature data exist  \*(e.g ERDA).`
      },
      {
        name: 'Latitude',
        param: 'latitude',
        type: 'number',
        description: `> To display Map Marker in PlantOverview Dashboard.`
      },
      {
        name: 'Longitude',
        param: 'longitude',
        type: 'number',
        description: `> To display Map Marker in PlantOverview Dashboard.`
      },
      {
        name: 'Name',
        param: 'name',
        type: 'text',
      },
  
  // device_id
  // inverter_name
  // added_on
  // updated_on
  // updated_by
  // inverter_room
    ]
  }

 
